import axios from 'axios'

const config = { skipBugReport: true, timeout: 8000 }

export function crearBugReport(payload) {
  return axios.post('bug-reports.add', payload, config)
}

export function listarBugReports(params) {
  return axios.get('bug-reports.list', { ...config, params })
}

export function obtenerBugReport(id) {
  return axios.get(`bug-reports.detalle/${id}`, config)
}

export function actualizarBugReport(id, payload) {
  return axios.patch(`bug-reports.update/${id}`, payload, config)
}

export function agregarNotaBugReport(id, nota) {
  return axios.post(`bug-reports.notes/${id}`, { nota }, config)
}

export function obtenerMetricasBugReports() {
  return axios.get('bug-reports.metrics', config)
}

export function eliminarBugReport(id) {
  return axios.delete(`bug-reports.delete/${id}`, config)
}
